module.exports = __webpack_public_path__ + "img/11087934_L.23d0cd11.png";